import { fetch } from '../helpers';

// Kicks off a server-side data-export job and polls until it's ready, then
// navigates to the resulting file. Shared by the trade download menu and the
// legacy Download button.
export class DownloadRequest {
  constructor(query, onComplete) {
    this.job = null;
    this.pingTimeout = null;
    this.pingCount = 0;
    this.onComplete = onComplete;

    this.init(query);
  }

  init(query) {
    const url = `${__config.api_path}downloads?${query.toString()}`;

    fetch(url, (data) => {
      this.job = data.job;
      this.ping();
    });
  }

  ping() {
    const delay = 500 + Math.sqrt(this.pingCount * 2) * 500;

    this.pingTimeout = window.setTimeout(() => {
      const url = `${__config.api_path}downloads/${this.job}`;

      fetch(url, (data) => {
        if (data.status === 'completed' && data.filename) {
          this.trigger(data.filename, data.url);
          return;
        }

        this.ping();
      });
    }, delay);

    this.pingCount++;
  }

  trigger(filename, url) {
    if (!url) {
      url = `/temp/${filename}`;
    }

    this.onComplete();

    window.location.href = url;
  }

  cancel() {
    console.log('Download cancelled');

    window.clearTimeout(this.pingTimeout);

    this.onComplete();
  }
}
